module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTDx2/yp+/zx2/z12/zt0/z11/0h+/z52/zx2/zx2/zx2/z50/zx4/zxs/z54/z52/0UHMlcAAAAQdFJOUwDHBuP4pogOPNNeu24yFCR7/ZSSAAAAzUlEQVQ4y8WU2w6DMAxD3TS90Zbx/1+7dhc0IaDepG1+iuAoEMctgMnocio1E5rcQsi1fgulCYYDDZQDFQupb4I+emVAL3Jq1QpGAWYKbEsKW0+SUmAOmC0DVrxseAfMNebbJ0N7FI9B26YSS4Buzd6vwJ722ovUCjHHU9sL5ttrLUC5h3XGxe6kx+q2UPtJzOijkDgwwXMNPYRqmdpegx//pu/eQ6TGU1UI/q4w0INy46ldZynHfQMNdz0CmQEzniEdqPRpSk4D5fKGhVeFX0thgnHl0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_icon_02_zh.png
// module id = pQZx
// module chunks = 34